const user_mixin = {
  computed: {
    user() {
      if (this.$store.state.user && typeof this.$store.state.user == 'string') {
        return JSON.parse(this.user)
      } else if(this.$store.state.user && typeof this.$store.state.user == 'object') {
        return this.$store.state.user
      } else {
        return {}
      }
    },
    is_vip() {
      if (this.user) {
        return this.user.db_vip == '1' || this.user.vip == '1'
      } else {
        return false
      }
    }
  }
}

export { user_mixin }
